import "core-js/modules/es.array.push.js";
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../assets/image/search.png';
import _imports_1 from '../../assets/imageerrey.png';
const _withScopeId = n => (_pushScopeId("data-v-1b617ddb"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1));
const _hoisted_2 = [_hoisted_1];
const _hoisted_3 = {
  class: "box"
};
const _hoisted_4 = {
  class: "gallery-title"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "图库目录", -1));
const _hoisted_6 = {
  class: "color"
};
const _hoisted_7 = {
  class: "gallery-years"
};
const _hoisted_8 = ["onClick"];
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "height": "84px"
  }
}, null, -1));
const _hoisted_10 = {
  class: "masonry"
};
const _hoisted_11 = ["onClick"];
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1));
const _hoisted_13 = {
  class: "title"
};
import nav_header from '@/components/nav_header.vue';
import axios from "axios"; //原生的axios 

import { tuku_list } from '@/util/http';
import { reactive } from 'vue';

import { useRouter } from 'vue-router';
import { ref, onBeforeMount } from 'vue';
export default {
  __name: 'gallery',
  setup(__props) {
    const router = useRouter();
    let activeIndex = ref(0);
    let years = reactive([
      // {years:'2023'},
      // {years:'2022'},
      // {years:'2021'},
      // {years:'2020'},
    ]);
    let masonry = ref([{
      image_path: 'https://picsum.photos/360/460?radom=' + Math.ceil(Math.random() * 100),
      name: '澳门跑狗'
    }]);
    let colorClik = index => {
      datas.page = 1;
      datas.masonry.length = 0;
      activeIndex.value = index;
      datas.color = index + 1;
      axiosTuku(2, index + 1, 1, datas.year);
    };
    let masonryDesc = data => {
      if (data.is_adv == 1) {
        window.location.href = data.adv_url;
      } else {
        router.push({
          path: `/gallery/detail/${data.id}/${data.issue}`
        });
      }
    };
    let galleryList = () => {
      router.push({
        path: `/gallery/list`
      });
    };
    onBeforeMount(() => {
      var datesc = new Date();
      let yearss = datesc.getFullYear();
      datas.year = datesc.getFullYear();
      for (var i = 0; i < 4; i++) {
        years.push({
          years: yearss - i
        });
      }
      console.log(years);
      axiosTuku(2, 1, 1, datas.year);
    });
    const loading = ref(false);
    const finished = ref(false);
    let datas = reactive({
      page: 1,
      masonry: [],
      year: '2023',
      color: 1
    });
    const onLoad = () => {
      // let tims = setTimeout(()=>{
      datas.page++;
      axiosTuku(2, activeIndex.value + 1, datas.page, datas.year);

      // },500)
    };

    let yearFun = item => {
      datas.year = item.years;
      datas.page = 1;
      datas.masonry.length = 0;
      axiosTuku(2, datas.color, 1, item.years);
    };
    let axiosTuku = (type, color, page, year) => {
      let url = `https://jl.tukuapi.com/api/tuku_list?lottery_type=${type}&color=${color}&page=${page}&year=${year}&is_new=1`;
      axios.get(url).then(res => {
        let data = res.data.data.data;
        if (data.length == 0) {
          finished.value = true;
        } else {
          datas.masonry.push(...data);
          loading.value = false;
        }
      });
    };
    return (_ctx, _cache) => {
      const _component_van_image = _resolveComponent("van-image");
      const _component_lazy_component = _resolveComponent("lazy-component");
      const _component_van_list = _resolveComponent("van-list");
      const _directive_lazy = _resolveDirective("lazy");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(nav_header, {
        name: "快乐8图库"
      }, {
        more: _withCtx(() => [_createElementVNode("div", {
          class: "log",
          onClick: _cache[0] || (_cache[0] = (...args) => _unref(galleryList) && _unref(galleryList)(...args))
        }, _hoisted_2)]),
        _: 1
      }), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_hoisted_5, _createElementVNode("div", _hoisted_6, [_createElementVNode("span", {
        onClick: _cache[1] || (_cache[1] = $event => _unref(colorClik)(0)),
        class: _normalizeClass(_unref(activeIndex) == 0 ? 'active' : '')
      }, "彩色", 2), _createElementVNode("span", {
        onClick: _cache[2] || (_cache[2] = $event => _unref(colorClik)(1)),
        class: _normalizeClass(_unref(activeIndex) == 1 ? 'active' : '')
      }, "黑白", 2)])]), _createElementVNode("ul", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(years), (item, index) => {
        return _openBlock(), _createElementBlock("li", {
          key: index,
          onClick: $event => _unref(yearFun)(item)
        }, [_createElementVNode("span", {
          class: _normalizeClass(_unref(activeIndex) ? 'na_icon_2' : '')
        }, null, 2), _createElementVNode("b", null, _toDisplayString(item.years) + " " + _toDisplayString(_unref(activeIndex) ? '黑白' : '彩色'), 1)], 8, _hoisted_8);
      }), 128))])]), _hoisted_9, _createVNode(_component_van_list, {
        loading: _unref(loading),
        "onUpdate:loading": _cache[3] || (_cache[3] = $event => _isRef(loading) ? loading.value = $event : null),
        finished: _unref(finished),
        "finished-text": "没有更多了",
        onLoad: onLoad
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_10, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(datas).masonry, (item, index) => {
          return _openBlock(), _createElementBlock("div", {
            class: "item",
            key: index,
            onClick: $event => _unref(masonryDesc)(item)
          }, [_createVNode(_component_lazy_component, null, {
            default: _withCtx(() => [_withDirectives((_openBlock(), _createBlock(_component_van_image, {
              src: item.image_path
            }, {
              error: _withCtx(() => [_hoisted_12]),
              _: 2
            }, 1032, ["src"])), [[_directive_lazy, item.image_path]])]),
            _: 2
          }, 1024), _createElementVNode("div", _hoisted_13, _toDisplayString(item.name), 1)], 8, _hoisted_11);
        }), 128))])]),
        _: 1
      }, 8, ["loading", "finished"])], 64);
    };
  }
};